import { IModel, Model } from "@common/models";

export interface IPetVisitRemindersModel extends IModel {
	petId: number;
	visitId: number;
	visitSalesItemId: number;
	salesItemId: number;
	dateGiven: string;
	dueDate: string;
	description: string;
	name: string;
	fullName: string;
	price: number;
	isPending: boolean;
	reminderDays: number;
	pastDueDate: boolean;
	isComingDue: boolean;
	given: boolean;
	salesItemTypeId: number;
}

export class PetVisitReminderModel extends Model implements IPetVisitRemindersModel {
	petId: number;
	visitId: number;
	visitSalesItemId: number;
	salesItemId: number;
	dateGiven: string;
	dueDate: string;
	description: string;
	name: string;
	fullName: string;
	price: number;
	isPending: boolean;
	reminderDays: number;
	pastDueDate: boolean;
	isComingDue: boolean;
	given: boolean;
	salesItemTypeId: number;

	constructor(params: IPetVisitRemindersModel) {
		super(params);
		this.petId = params.petId;
		this.visitId = params.visitId;
		this.visitSalesItemId = params.visitSalesItemId;
		this.salesItemId = params.salesItemId;
		this.dateGiven = params.dateGiven;
		this.dueDate = params.dueDate;
		this.description = params.description;
		this.name = params.name;
		this.fullName = params.fullName;
		this.price = params.price;
		this.isPending = params.isPending;
		this.reminderDays = params.reminderDays;
		this.pastDueDate = params.pastDueDate;
		this.isComingDue = params.isComingDue;
		this.given = params.given;
		this.salesItemTypeId = params.salesItemTypeId;
	}
}
